import React from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'
import VendorList from '../../components/vendor/VendorList'

const Vendor = () => {
    return (
        <>
            <PageTitleAndSnackBar pageTitle={"Vendor"} />
            <VendorList />
        </>
    )
}

export default Vendor